"use client";
import React, { useState } from "react";
import {
  Box,
  HStack,
  IconButton,
  VStack,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import Image, { StaticImageData } from "next/image";
import { HiArrowLeft, HiArrowRight } from "@onemind-services-llc/react-icons-ng/hi";
import { Carousel } from "@onemind-services-llc/ui-components";
import { useCustomerCarousel } from "@/hooks/useCustomCarousel";
import { SectionDivider } from "../SectionDivider";
import { CUSTOMER_LIST } from "./customers.constants";

type Props = { image: StaticImageData; name: string };

const CustomerCard = (props: Props) => {
  const { image, name } = props;
  return (
    <Box p={4}>
      <Box height={"120px"} position={"relative"} w="full">
        <Image
          alt={name}
          title={name}
          blurDataURL={
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
          }
          fill
          placeholder="blur"
          src={image}
          sizes="(max-width: 600px) 100vw, 600px"
          style={{ objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

const CustomCarousel = () => {
  const slidesToShow = useBreakpointValue({ base: 1, sm: 3, md: 4, lg: 6 });

  const [carouselActions, setCarouselActions] = useState({
    slickPrev: () => {},
    slickNext: () => {},
  });

  const { slickPrev, slickNext } = carouselActions;
  const { settings } = useCustomerCarousel({
    dots: false,
    autoplay: true,
    slidesToShow: slidesToShow,
  });

  return (
    <Stack data-cy={"section-customers"}>
      <SectionDivider label="Trusted By" />
      <VStack spacing={4}>
        <Box mx={{ sm: "-1rem" }} w="100%">
          <Carousel settings={settings} setSliderRef={setCarouselActions}>
            {CUSTOMER_LIST.map((customer, index) => (
              <Box key={index} px="1rem">
                <CustomerCard image={customer.path} name={customer.name} />
              </Box>
            ))}
          </Carousel>
        </Box>
        <HStack spacing={6}>
          <IconButton
            aria-label="previous"
            color="brand.100"
            fontSize="30px"
            icon={<HiArrowLeft />}
            onClick={slickPrev}
            variant={"ghost"}
          />
          <IconButton
            aria-label="next"
            color="brand.100"
            fontSize="30px"
            icon={<HiArrowRight />}
            onClick={slickNext}
            variant={"ghost"}
          />
        </HStack>
      </VStack>
    </Stack>
  );
};

export default CustomCarousel;
